import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PosLoginResponseService } from '../../../services/pos.login.response.service';

@Component({
  selector: 'app-search-header-modal',
  templateUrl: './search-header-modal.component.html',
  styleUrl: './search-header-modal.component.scss'
})
export class SearchHeaderModalComponent implements OnInit {
  searchTerm = '';
  searchResults: any[] = [];
  menuData: any[] = []; 



  constructor(public dialogRef: MatDialogRef<SearchHeaderModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {menuData : any[]},
    private router: Router,
    private loginService : PosLoginResponseService
  ) { }

  ngOnInit(): void {
    this.menuData =  this.dialogData.menuData
    
  }

  closeSearchModal() {
    this.searchTerm = '';
    this.searchResults = [];
    this.dialogRef.close();
  }

  onSearch() {
    this.searchResults = this.menuData.filter(item =>
      item.menuIdentifierText.toLowerCase().includes(this.searchTerm.toLowerCase())
    ).map(item => ({
      label: item.menuIdentifierText,
      url: item.url
    }));
  }
  navigateTo(item: any) {
    this.closeSearchModal();
    this.router.navigate([item.url]);
  }
}
